import React, {Component} from 'react';
import {
    Navbar,
    NavbarBrand,
    Nav,
    NavLink,
    NavItem,
    NavbarToggler,
    Collapse
} from 'reactstrap'

import styles from './PublicFooter.css'

export default class PublicFooter extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: true
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        const { iframe } = this.props;

        return (
            <div>
                <Navbar className={[styles.footer, iframe ? styles.iframe : ""].join(' ')} expand="md">
                    <NavbarBrand href="/">© 2018 Quickdoctor</NavbarBrand>
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <NavLink href="/kontakt">Kontakt</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="/impressum">Impressum</NavLink>
                            </NavItem>
                          <NavItem>
                            <NavLink href="/datenschutz">Datenschutz</NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink href="/agb">AGB</NavLink>
                          </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PublicFooter/PublicFooter.js